import React, { useEffect } from 'react';
import './StarBackground.css';

function StarBackground() {
  useEffect(() => {
    const container = document.querySelector('.star-container');
    const count = 500;

    for (let i = 0; i < count; i++) {
      const star = document.createElement('div');
      star.className = 'star';

      const size = Math.random() * 2 + 1;
      star.style.width = `${size}px`;
      star.style.height = `${size}px`;
      star.style.top = `${Math.random() * 100}vh`;
      star.style.left = `${Math.random() * 100}vw`;
      star.style.animationDelay = `${Math.random() * 5}s`;
      star.style.animationDuration = `${Math.random() * 3 + 2}s`;

      container.appendChild(star);
    }
  }, []);

  return <div className="star-container"></div>;
}

export default StarBackground;
